import { SESSION_PROFILE_SET } from "../constants/ActionTypes";

/**
 * In-memory B2B session profile (firmUserId, tenantId, menu flags, …).
 * Filled from /FirmAuth/Me via RequestHandler.setProfile; cleared on logout.
 * Not persisted to localStorage.
 */
let profile = null;

const syncRedux = (payload) => {
  try {
    const { getStore } = require("../appRedux/store");
    const store = getStore();
    if (store) {
      store.dispatch({ type: SESSION_PROFILE_SET, payload });
    }
  } catch (e) {
    // store not ready yet
  }
};

/** Normalize FirmAuth login/Me payload into a stable shape for the UI. */
export const normalizeFirmProfile = (raw) => {
  if (!raw) return null;
  const userId = raw.firmUserId ?? raw.userId ?? null;
  const userName = raw.name ?? raw.userName ?? null;
  return {
    ...raw,
    userId,
    firmUserId: raw.firmUserId ?? userId,
    userName,
    name: raw.name ?? userName,
    email: raw.email ?? null,
    tenantId: raw.tenantId ?? null,
    firmId: raw.firmId ?? null,
    firmName: raw.firmName ?? null,
    subFirmId: raw.subFirmId ?? null,
    isSubFirm: !!(raw.subFirmId || raw.isSubFirm),
    usePaymentSet: !!raw.usePaymentSet,
    menu: {
      paymentPlan: !!raw.paymentPlan,
      collectionPlan: !!raw.collectionPlan,
      posCollection: !!raw.posCollection,
      stocks: !!raw.stocks,
      dbsInvoices: !!raw.dbsInvoices,
      invoiceDiscount: !!raw.invoiceDiscount,
      erpReport: !!raw.erpReport,
      createPaymentLink: !!raw.createPaymentLink,
      addSubFirm: !!raw.addSubFirm,
      b2BMenuLinkItemLink: raw.b2BMenuLinkItemLink,
      b2BMenuLinkItemTitle: raw.b2BMenuLinkItemTitle,
      b2BPdfFilePath: raw.b2BPdfFilePath,
      firmTransaction: !!raw.firmTransaction,
      riskAnalysis: !!raw.riskAnalysis,
      useSavedCard: !!raw.useSavedCard,
    },
    tenantLogo: raw.tenantLogo ?? null,
    csrfToken: raw.csrfToken ?? null,
  };
};

export const setSessionProfile = (nextProfile) => {
  if (!nextProfile) {
    profile = null;
    syncRedux(null);
    return;
  }
  profile = normalizeFirmProfile(nextProfile);
  syncRedux(profile);
};

export const clearSessionProfile = () => {
  profile = null;
  syncRedux(null);
};

export const getProfile = () => profile;

export const getUserId = () =>
  profile?.userId != null ? String(profile.userId) : null;

export const getTenantId = () =>
  profile?.tenantId != null ? String(profile.tenantId) : null;

export const getEmail = () => profile?.email ?? null;

export const getUserName = () => profile?.userName ?? null;

export const getFirmName = () => profile?.firmName ?? null;

export const getFirmId = () =>
  profile?.firmId != null ? String(profile.firmId) : null;

export const getMenu = () => profile?.menu ?? null;

export const getIsSubFirm = () => !!profile?.isSubFirm;

export const getUsePaymentSet = () => !!profile?.usePaymentSet;

export const getTenantLogo = () => profile?.tenantLogo ?? null;
